import instanceQuery from 'graphql/queries/supplier/PurchaseCreditTransactionQuery.graphql';
import fragment from 'graphql/fragments/nominal/PostedTransactionsFragment.graphql';

const PurchaseCreditTransactions = {
  type: 'PostedTransactionsResponse',
  formTitle: 'Posted Transactions',
  instance: instanceQuery,
  fragment,
};

export default PurchaseCreditTransactions;
